import { render, staticRenderFns } from "./__Status.vue?vue&type=template&id=71dd36cd&"
import script from "./__Status.vue?vue&type=script&lang=js&"
export * from "./__Status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports